import React from 'react';
import {
  HashRouter, Route, Switch, Redirect,
} from 'react-router-dom';
import { Layout } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { logoutAction } from './state/actions/creators/auth.actioncreator';
import LoginPage from './modules/app/pages/login.page';
import SsoPage from './modules/app/pages/sso.page';
import routes from './routes';
import StorePreloader from './modules/app/components/StorePreloader';

const { Content } = Layout;

export const ROUTES = { LOGOUT: 'logout' };


function AppRouter({
  history, authenticated, router,
}) {
  if (authenticated) {
    return (
      <div>
        <StorePreloader />
        <HashRouter history={history}>
          <Layout>
            <Content>
              <Switch>
                {routes.map(({ exact, path, Component }, i) => (
                  <Route key={i} exact={exact} path={path} component={Component} />
                ))}
                <Redirect to="/noconformidades/listar" />
              </Switch>
            </Content>
          </Layout>
        </HashRouter>
      </div>
    );
  }
  return (
    <HashRouter history={history}>
      <Switch>
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/sso/:ssotoken" component={SsoPage} />
        <Redirect to="/login" />
      </Switch>
    </HashRouter>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logoutAction }, dispatch);
}

function mapStateToProps({ navigation, router }) {
  return {
    navigation,
    router,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppRouter);
